module.exports = __webpack_public_path__ + "img/60.93c514cd.png";